export default __webpack_public_path__ + "static/media/verify-id.a2f3f5ce.jpg";